import React from "react";
import { ChatMessage } from "../../types/chatbot";

interface MessageBubbleProps {
  message: ChatMessage;
  streaming?: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  const isUser = message.role === "user";
  return (
    <div
      className={`chatbot-msg ${
        isUser ? "chatbot-msg--user" : "chatbot-msg--assistant"
      }`}
    >
      <div className="chatbot-msg__avatar" aria-hidden>
        <i className={`fas fa-${isUser ? "user" : "robot"}`}></i>
      </div>
      <div className="chatbot-msg__body">
        <div className="chatbot-msg__bubble">{message.content}</div>
      </div>
    </div>
  );
};

export default MessageBubble;
